import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  viewChild,
} from '@angular/core';
import { CountdownComponent, CountdownEvent } from 'ngx-countdown';

@Component({
  selector: 'stx-ui-countdown',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CountdownComponent],
  host: {
    class:
      'text-sm sm:test-base text-center flex flex-row items-center gap-2 bg-secondary-container px-2 rounded-lg text-on-secondary-container',
  },
  styles: `
    @reference '../../../../theming/src/lib/tailwind/reference.css';

    :host {
      stx-ui-icon {
        @apply inline text-on-primary-container;
      }
    }
  `,
  template: `
    <countdown
      [config]="{
        leftTime: duration(),
        format: countdownFormat(),
        notify: 300,
      }"
      (event)="onCountdownEvent($event)"
    />
  `,
})
export class SharedUiCountdownComponent {
  readonly duration = input<number>(0);
  finished = output<boolean>();
  warning = output<number>();
  readonly #hasFinished = computed(() => this.duration() <= 0);
  readonly countdown = viewChild.required(CountdownComponent);

  protected readonly countdownFormat = computed(() => {
    const durationInSeconds = this.duration();
    const TWO_DAYS = 172800;
    const ONE_DAY = 86400;
    const ONE_HOUR = 3600;

    if (durationInSeconds >= TWO_DAYS) return "d 'días' HH:mm:ss";
    if (durationInSeconds >= ONE_DAY) return "d 'día' HH:mm:ss";
    if (durationInSeconds >= ONE_HOUR) return 'HH:mm:ss';
    return 'mm:ss';
  });

  stop() {
    this.countdown().stop();
  }

  onCountdownEvent(event: CountdownEvent) {
    if (event.action === 'done' && !this.#hasFinished()) {
      this.finished.emit(true);
    } else if (event.action === 'notify') {
      this.warning.emit(event.left);
    }
  }
}
